import VideoControls from "@components/VideoControls";
import { $ } from "@utils/dom";
import { on, off } from "@utils/listener";

class ProjectVideoPlayer {
  constructor(el, emitter) {
    this.el = el;
    this.emitter = emitter;
    this.btn = $('.project-video-player__wrap', this.el);
    this.media = $('.project-video-player__video, .project-video-player__img', this.el);
    this.controls = $('.project-video-player__controls', this.el);

    this._onBtnClick = this._onBtnClick.bind(this);
  }

  init() {
    if( this.controls ) this.controls = new VideoControls(this.controls, this.btn);

    this._bindEvents();
  }
  destroy() {
    this._unbindEvents();

    if( this.controls ) this.controls.destroy();

    this.el = null;
    this.emitter = null;
    this.btn = null;
    this.media = null;
    this.controls = null;

    this._onBtnClick = null;
  }

  _bindEvents() {
    if( this.btn ) on(this.btn, 'click', this._onBtnClick);
  }
  _unbindEvents() {
    if( this.btn ) off(this.btn, 'click', this._onBtnClick);
  }

  _onBtnClick(event) {
    if( event ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    this.emitter.emit('SiteVideo.play', this.el.dataset.projectVideoPlayer, this.media);
  }
}

export default ProjectVideoPlayer;
